import {
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import { SettingsSection } from '$common/settings-section'
import { t } from '$i18n'
import {
  showDeleteSyncedContactsConfirmationDialog,
  showDisableRecentUsersModal,
  showReloadContactsDialog,
} from '$comp/modals/confirmation-dialog'
import { LabeledSwitch } from '$common/labeled-switch'
import { SettingsIntendedDivider } from '$common/settings-item'
import {
  setRecentUsersIsEnabled,
  useAutoSyncContactsIsEnabled,
  useRecentUsersIsEnabled,
} from '$logic/client-device'
import {
  clearContacts,
  reloadContacts,
  changeAutoSyncContacts,
} from '$logic/contacts/service'
import { isAndroidApp } from '$func/environmentInfo'
import { isContactPermissionAllowedByClientUser } from '$logic/twaCommunication'
import { showContactsPermissionDeniedDialog } from '$comp/modals/permission-dialog'

const StyledListItemButton = styled(ListItemButton)`
  box-sizing: border-box;
  padding: 5px 25px 5px 20px;
  min-height: 50px;
`

export function SettingsContacts() {
  const autoSyncContactsIsEnabled = useAutoSyncContactsIsEnabled()
  const recentUsersIsEnabled = useRecentUsersIsEnabled()

  const updateRecentUsers = async (enabled: boolean) => {
    await setRecentUsersIsEnabled(enabled)
    analite('PROFILE_SETTING_SUGGEST_FREQUENT_CONTACTS', {
      active: enabled,
    })
  }

  const toggleRecentUsers = () => {
    if (recentUsersIsEnabled) {
      showDisableRecentUsersModal(() => updateRecentUsers(false))
      return
    }
    updateRecentUsers(true)
  }

  const deleteSyncedContacts = () => {
    analite('PROFILE_SETTING_DELETE_SYNCED_CONTACTS')
    showDeleteSyncedContactsConfirmationDialog(clearContacts)
  }

  const isContactPermissionAllowed = isContactPermissionAllowedByClientUser()

  const onReloadContacts = async () => {
    if (!isContactPermissionAllowed) {
      showContactsPermissionDeniedDialog()
      return
    }
    showReloadContactsDialog(async () => {
      analite('PROFILE_SETTING_RELOAD_CONTACTS')
      await reloadContacts()
    })
  }
  return (
    <SettingsSection headerText={t('myAccount.contact')}>
      <>
        {isAndroidApp && (
          <>
            <LabeledSwitch
              label={t('settings.sections.contacts.sync')}
              checked={autoSyncContactsIsEnabled && isContactPermissionAllowed}
              onChange={
                isContactPermissionAllowed
                  ? () => {
                      analite('PROFILE_SETTING_SYNC_CONTACTS', {
                        active: !autoSyncContactsIsEnabled,
                      })
                      changeAutoSyncContacts(!autoSyncContactsIsEnabled)
                    }
                  : showContactsPermissionDeniedDialog
              }
            />
            <SettingsIntendedDivider />
          </>
        )}

        <LabeledSwitch
          label={t('settings.sections.contacts.repetitiveContacts')}
          checked={recentUsersIsEnabled}
          onChange={toggleRecentUsers}
        />

        <ListItem disablePadding>
          <StyledListItemButton onClick={deleteSyncedContacts}>
            <ListItemText
              primary={
                <Typography component="p" variant="body2">
                  {t('settings.sections.contacts.deleteSyncContacts')}
                </Typography>
              }
            />
          </StyledListItemButton>
        </ListItem>
        {isAndroidApp && (
          <>
            <SettingsIntendedDivider />
            <ListItem disablePadding>
              <StyledListItemButton onClick={onReloadContacts}>
                <ListItemText
                  primary={
                    <Typography component="p" variant="body2">
                      {t('settings.sections.contacts.reloadContacts')}
                    </Typography>
                  }
                />
              </StyledListItemButton>
            </ListItem>
          </>
        )}
      </>
    </SettingsSection>
  )
}
